module.exports = __webpack_public_path__ + "img/big-n.cb7b3b6.svg";